import * as z from "zod/v4";

/** Per-product status for v2 onboarding UI (includes not-started when no row). */
export const onboardingV2ProductStatusUiSchema = z.enum([
  "completed",
  "partial-completion",
  "help-requested",
  "not-started",
]);

export type OnboardingV2ProductStatusUi = z.infer<
  typeof onboardingV2ProductStatusUiSchema
>;

export const getOnboardingV2ProductStatuses = {
  name: "getOnboardingV2ProductStatuses" as const,
  input: z.object({ teamId: z.string().min(1) }),
  output: z.object({
    teamName: z.string(),
    teamDomain: z.string().nullable(),
    returns: onboardingV2ProductStatusUiSchema,
    orderEditing: onboardingV2ProductStatusUiSchema,
  }),
};

export type GetOnboardingV2ProductStatusesInput = z.infer<
  typeof getOnboardingV2ProductStatuses.input
>;
export type GetOnboardingV2ProductStatusesOutput = z.infer<
  typeof getOnboardingV2ProductStatuses.output
>;
